import { createFileRoute } from "@tanstack/react-router";
import Ayuda from "@/pages/site/Ayuda";

export const Route = createFileRoute("/ayuda")({
  component: () => <Ayuda />,
});
